import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Default Suspense fallback for lazy-loaded route pages (Phase B).
 */
export default function PageRouteFallback() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
      }}
      role="progressbar"
      aria-label="Loading page"
    >
      <CircularProgress />
    </Box>
  );
}
